module.exports = __webpack_public_path__ + "static/media/banner_.5d6ed20d.webp";